export default "__VITE_ASSET__BgeHIJ6M__"